import { render, staticRenderFns } from "./galleryListComponent.vue?vue&type=template&id=312a899f&scoped=true"
import script from "./galleryListComponent.vue?vue&type=script&lang=js"
export * from "./galleryListComponent.vue?vue&type=script&lang=js"
import style0 from "./galleryListComponent.vue?vue&type=style&index=0&id=312a899f&prod&scoped=true&lang=css"
import style1 from "./galleryListComponent.vue?vue&type=style&index=1&id=312a899f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312a899f",
  null
  
)

export default component.exports